import { appReady, closeModal } from 'actions/app'
import {
  addEmptyItem,
  brandAdded,
  brandDeleted,
  brandsFetched,
  brandUpdated,
  farmCreated,
  removeEmptyItem,
  farmUpdated,
  farmsFetched,
  farmDeleted,
} from 'actions/farm'
import http from 'common/http'
import {
  farmReferenceAdded,
  farmReferenceDeleted,
  farmReferenceUpdated,
} from 'actions/client'

export const createFarm = (data) => {
  return (dispatch) => {
    return http.post('/farm', data).then((res) => {
      dispatch(farmCreated(res.data))
      dispatch(closeModal())
      //For updating the client to show the updated farms
      dispatch(farmReferenceAdded(res.data))
      return {
        data: res.data,
        message: 'Farm created',
      }
    })
  }
}

export const getFarms = (data?) => {
  return (dispatch) => {
    return http.get('/farm', data).then((res) => {
      dispatch(farmsFetched(res.data.results))
    })
  }
}

export const getFarmsPaginated = (
  page = 1,
  pageSize = 10,
  search = '',
  clientId?: number,
  archived = 'false',
) => {
  const params: Record<string, string | number | boolean | undefined> = {
    page,
    pageSize,
    archived,
  }
  if (search) {
    params.search = search
  }
  if (clientId) {
    params.clientId = clientId
  }
  return http.get('/farm', { params })
}

export const getFilteredFarms = (clientId) => {
  return (dispatch) => {
    const params = { params: { clientId: clientId } }
    return http.get('/farm', params).then((res) => {
      dispatch(farmsFetched(res.data.results))
    })
  }
}

export const editFarm = (data) => {
  const { name, clientId } = data
  return (dispatch) => {
    return http.put(`/farm/${data['id']}`, { name, clientId }).then((res) => {
      dispatch(closeModal())
      dispatch(farmUpdated(res.data))
      //For updating the client to show the updated farms
      dispatch(farmReferenceUpdated(data))
    })
  }
}
export const deleteFarm = (id, clientId) => {
  return (dispatch) => {
    return http.delete(`/farm/${id}`).then(() => {
      dispatch(closeModal())
      dispatch(farmDeleted(id))
      //For updating the client object to show the number of farms he has
      dispatch(farmReferenceDeleted(id, clientId))
    })
  }
}
export const deleteFarms = (ids, clientsToUpdate, cascade = false) => {
  return (dispatch) => {
    let query = ''
    if (cascade) {
      query = '?cascade=true'
    }
    return http.delete(`/farm/delete-multiple/${ids}${query}`).then(() => {
      dispatch(closeModal())
      for (const clientId in clientsToUpdate) {
        for (const farmId of clientsToUpdate[clientId]) {
          dispatch(farmDeleted(farmId))
          dispatch(farmReferenceDeleted(farmId, parseInt(clientId)))
        }
      }
    })
  }
}

export const deleteEmptyObj = (column) => {
  return (dispatch) => {
    dispatch(removeEmptyItem(column))
  }
}

export const addEmptyObj = (id, data, column) => {
  return (dispatch) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch((addEmptyItem as any)(id, data, column))
  }
}

export const farmSetUpComplete = () => {
  return (dispatch) => {
    dispatch(appReady())
  }
}

export function createBrand(data) {
  return (dispatch) => {
    return http
      .post('/make-brand', data)
      .then((res) => {
        dispatch(brandAdded(res.data))
        return res.data
      })
      .catch(() => {})
  }
}

export const updateBrand = (data) => {
  return (dispatch) => {
    return http
      .put('/make-brand', data)
      .then(() => {
        dispatch(brandUpdated(data))
      })
      .catch(() => {})
  }
}

export const deleteBrand = (id) => {
  return (dispatch) => {
    return http
      .delete('/make-brand')
      .then(() => {
        dispatch(brandDeleted(id))
      })
      .catch(() => {})
  }
}

export const fetchBrands = () => {
  return (dispatch) => {
    return http
      .get('/make-brand')
      .then((res) => {
        dispatch(brandsFetched(res.data))
      })
      .catch(() => {})
  }
}

export const archiveFarms = (data, callback) => {
  return (dispatch) => {
    return http.post('/farm/archive', data).then((res) => {
      dispatch(closeModal())
      if (callback) {
        callback()
      }
    })
  }
}

export const restoreFarms = (farmIds, callback) => {
  return (dispatch) => {
    return http.post('/farm/restore', { farmIds }).then((res) => {
      dispatch(farmsFetched(res.data.farms))
      dispatch(closeModal())
      if (callback) {
        callback()
      }
    })
  }
}
